import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_USER = `${API_URL}/partners-logo`;
const ADD_USER_DETAILS = `${API_URL}/partners-logo`;

export const getPartnerLogos = createAsyncThunk(
  "getPartnerLogos",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_USER}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addPartnerDetails = createAsyncThunk(
  "addPartnerDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let selectedPage = values.get("selectedPage")
      const { data } = await axios.post(`${ADD_USER_DETAILS}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getPartnerLogos({ page: selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

